import Poster from "@/util/poster"
import BaseLogic from "../base_logic"
import {
  LatLonFilialeRequest,
  RemoteResult,
  FilialeLiefergebietResult,
  AbholzeitType,
  Terminart,
  BPBeginnenRequest,
  Bestellung,
  BestellungQueryRequest,
  BuchungList,
  Reservierung,
} from "mangdto"
import {
  BestellungPending,
  BestellungPending_Lieferung as Lieferung,
} from "mangdto"
import RestPaths from "@/util/rest_paths"
import router from "@/router"
import RouteNames from "@/util/route_names"
import vuexStore from "@/store"

export default class FilialeMainLogic extends BaseLogic {
  liefergebiet: FilialeLiefergebietResult = null
  insertWorking: boolean = false
  insertError: boolean = false
  //aktuelleBestellungen: Bestellung[] = []
  bestellungenAll: any[] = []

  init() {
    if (this.mainLogic.standort) {
      var liefergebietRequest = new LatLonFilialeRequest()
      liefergebietRequest.filialeId = this.mainLogic.filiale.filialeId
      liefergebietRequest.latitude = this.mainLogic.standort.latitude
      liefergebietRequest.longitude = this.mainLogic.standort.longitude

      Poster.postUser<RemoteResult<FilialeLiefergebietResult>>(
        RestPaths.filialeLiefergebietStandort,
        liefergebietRequest,
      ).then((response) => {
        if (response.data.success) {
          this.liefergebiet = response.data.payload
        }
      })
    }

    // var request = new BestellungFilialeRequest()
    // request.identifierId = vuexStore.state.user.identifier
    // request.filialeId = this.mainLogic.filiale.filialeId

    // Poster.postUser<RemoteResult<BestellungList>>(
    //   RestPaths.bestellungKundeFilialeAktuell,
    //   request
    // ).then((response) => {
    //   if (response.data.success) {
    //     this.aktuelleBestellungen = response.data.payload.list
    //   }
    // })

    var allRequest = new BestellungQueryRequest()
    allRequest.identifier = vuexStore.state.user.identifier

    Poster.postUser<RemoteResult<BuchungList>>(
      RestPaths.bestellungKundeListeAll,
      allRequest,
    ).then((response) => {
      if (response.data.success) {
        this.bestellungenAll = response.data.payload.list
      }
    })
  }

  lieferungWaehlen() {
    this.insertWorking = true

    // if (this.mainLogic.bestellungPending != null) {
    //   if (this.mainLogic.bestellungPending.terminart == Terminart.LIEFERUNG) {
    //     // if (this.mainLogic.bestellungPending.lieferung.liefergebietId) {
    //     //   router.push({ name: RouteNames.NEU.TERMIN_LIEFERUNG })
    //     // } else {
    //     //  router.push({ name: RouteNames.NEU.STANDORT_LIEFERUNG_PLZ })
    //     // }
    //     this.insertWorking = false

    //     return
    //   }
    // }

    var request = new BPBeginnenRequest()
    request.id = vuexStore.state.user.identifier
    request.filialeId = this.mainLogic.filiale.filialeId
    request.terminart = Terminart.Lieferung
    request.identifier = vuexStore.state.user.identifier
    if (this.liefergebiet) {
      request.liefergebietId = this.liefergebiet.liefergebietId
    }

    if (this.mainLogic.standort) {
      request.lieferungStrasse = this.mainLogic.standort.strasse
      request.lieferungPlz = this.mainLogic.standort.plz
      request.lieferungOrt = this.mainLogic.standort.ort
    }

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnen,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.bestellungPending.terminart = Terminart.Lieferung
        this.mainLogic.bestellungPending.lieferung = new Lieferung()
        if (this.mainLogic.standort) {
          this.mainLogic.bestellungPending.lieferung.kundeStrasse =
            this.mainLogic.standort.strasse
          this.mainLogic.bestellungPending.lieferung.kundePlz =
            this.mainLogic.standort.plz
          this.mainLogic.bestellungPending.lieferung.kundeOrt =
            this.mainLogic.standort.ort
        }
        if (this.liefergebiet) {
          this.mainLogic.bestellungPending.lieferung.liefergebietId =
            this.liefergebiet.liefergebietId
          this.mainLogic.bestellungPending.lieferung.lieferkosten =
            this.liefergebiet.lieferkosten
        }

        this.mainLogic.neueBestellung = true

        // if (this.mainLogic.bestellung.lieferung.liefergebietId) {
        //   router.push({ name: RouteNames.NEU.TERMIN_LIEFERUNG })
        // } else {
        router.push({ name: RouteNames.NEU.STANDORT_LIEFERUNG_PLZ })
        //   }
        // } else {
        //   this.insertError = true
      }
    })
  }

  abholungWaehlen() {
    if (this.mainLogic.bestellungPending != null) {
      if (this.mainLogic.bestellungPending.terminart == Terminart.Abholung)
        if (this.mainLogic.filiale.abholungSettings.supportsVorbestellung) {
          router.push({ name: RouteNames.NEU.TERMIN_ABHOLUNG })
        } else {
          if (this.mainLogic.filiale.abholungSettings.verzehrVorOrt) {
            router.push({ name: RouteNames.NEU.VERZEHRART })
          } else {
            router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
          }
          return
        }
    }

    var request = new BPBeginnenRequest()
    request.id = vuexStore.state.user.identifier
    request.filialeId = this.mainLogic.filiale.filialeId
    request.terminart = Terminart.Abholung
    request.identifier = vuexStore.state.user.identifier

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnen,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.bestellungPending.terminart = Terminart.Abholung
        if (!this.mainLogic.filiale.abholungSettings.supportsVorbestellung) {
          this.mainLogic.bestellungPending.abholung.abholzeitType =
            AbholzeitType.Baldest
        }

        this.mainLogic.neueBestellung = true

        if (this.mainLogic.filiale.abholungSettings.supportsVorbestellung) {
          router.push({ name: RouteNames.NEU.TERMIN_ABHOLUNG })
        } else {
          if (this.mainLogic.filiale.abholungSettings.verzehrVorOrt) {
            router.push({ name: RouteNames.NEU.VERZEHRART })
          } else {
            router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
          }
        }
      }
    })
  }

  reservierungWaehlen() {
    router.push({ name: RouteNames.NEU.TERMIN_RESERVIERUNG })
  }

  sofortbestellungWaehlen() {
    if (this.mainLogic.bestellungPending != null) {
      if (
        this.mainLogic.bestellungPending.terminart == Terminart.Sofortbestellung
      ) {
        router.push({ name: RouteNames.NEU.SOFORTBESTELLUNG_TISCH })
        return
      }
    }

    var request = new BPBeginnenRequest()
    request.id = vuexStore.state.user.identifier
    request.filialeId = this.mainLogic.filiale.filialeId
    request.terminart = Terminart.Sofortbestellung
    request.identifier = vuexStore.state.user.identifier

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnen,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.bestellungPending.terminart = Terminart.Sofortbestellung
        this.mainLogic.neueBestellung = true

        router.push({ name: RouteNames.NEU.SOFORTBESTELLUNG_TISCH })
      }
    })
  }

  get lieferungDisabled(): boolean {
    if (!this.mainLogic.filiale.zurZeitGeoeffnetLieferung) {
      if (!this.mainLogic.filiale.lieferungSettings.supportsTermin) {
        return true
      }
    }
    return false
  }

  get abholungDisabled(): boolean {
    if (!this.mainLogic.filiale.zurZeitGeoeffnetKueche) {
      if (!this.mainLogic.filiale.abholungSettings.supportsVorbestellung) {
        return true
      }
    }
    return false
  }

  get reservierungDisabled(): boolean {
    return false
  }

  get sofortDisabled(): boolean {
    return !this.mainLogic.filiale.zurZeitGeoeffnetKueche
  }

  get abholungText(): string {
    if (!this.mainLogic.filiale.zurZeitGeoeffnet) {
      if (this.mainLogic.filiale.abholungSettings.supportsVorbestellung) {
        return "Für Abholung vorbestellen"
      } else {
        return "Zur Zeit kein Abholung"
      }
    }

    if (
      this.mainLogic.neueBestellung &&
      this.mainLogic.bestellungPending.terminart == Terminart.Abholung
    ) {
      return "Bestellung fortsetzen"
    }

    return "Für Abholung bestellen"
  }

  get lieferungText(): string {
    if (!this.mainLogic.filiale.zurZeitGeoeffnetLieferung) {
      if (this.mainLogic.filiale.lieferungSettings.supportsTermin) {
        return "Für Lieferung vorbestellen"
      } else {
        return "Zur Zeit keine Lieferung"
      }
    }
    return "Für Lieferung bestellen"
  }

  bestellungAnzeigen(bestellung: Bestellung) {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { bestellungId: bestellung.id },
    })
  }

  reservierungAnzeigen(reservierung: Reservierung) {
    router.push({
      name: RouteNames.RESERVIERUNG.DETAILS,
      params: { reservierungId: reservierung.id },
    })
  }
}
